import { render, staticRenderFns } from "./AssignmentList.vue?vue&type=template&id=25e3666e&scoped=true&"
import script from "./AssignmentList.vue?vue&type=script&lang=js&"
export * from "./AssignmentList.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentList.vue?vue&type=style&index=0&id=25e3666e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3666e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VBtn,VCard,VDataTable,VIcon,VSkeletonLoader})
